<template>
  <div id="app">
    <b-card>
      <div slot="header">
        <strong>Recycle Bin</strong>
      </div>
      <b-input-group class="mb-3">
        <template #prepend>
          <b-input-group-text>
            <font-awesome-icon :icon="['fas', 'search']" />
          </b-input-group-text>
        </template>
        <b-form-input
          ref="currentInput"
          v-model="searchFilter"
          type="text"
          placeholder="Search"
          @input="searchChanged($event)"
        />
      </b-input-group>

      <div class="table-container">
        <b-table-simple
          class="recycle-bin-table"
          responsive="true"
          hover
          outlined
        >
          <b-thead head-variant="light">
            <b-tr>
              <b-th />
              <b-th>ID</b-th>
              <b-th>Type</b-th>
              <b-th>Name</b-th>
              <b-th>Deleted By</b-th>
              <b-th>Deleted At</b-th>
              <b-th
                class="text-left"
                style="width: 13em"
              >
                Action
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="module in recycleBin.data">
              <b-tr class="module-row">
                <b-td>
                  <div
                    v-if="module.folders && module.folders.length > 0"
                    class="text-center padding-13"
                  >
                    <font-awesome-icon
                      v-if="!module.showDetails"
                      :icon="['fas', 'plus']"
                      @click="toggleModule(module)"
                    />
                    <font-awesome-icon
                      v-if="module.showDetails"
                      :icon="['fas', 'minus']"
                      @click="toggleModule(module)"
                    />
                  </div>
                </b-td>

                <b-td class="module-padding">
                  {{ module.id }}
                </b-td>
                <b-td>{{ module.type }}</b-td>
                <b-td>{{ module.moduleName }}</b-td>
                <b-td>{{ module.deletedBy }}</b-td>
                <b-td>{{ module.deletedAt }}</b-td>
                <b-td>
                  <b-btn
                    v-if="module.deletedAt"
                    size="sm"
                    variant="success"
                    @click="onRestoreModule(module)"
                  >
                    Restore
                  </b-btn>
                </b-td>
              </b-tr>


              <template
                v-for="folder in module.folders"
                v-if="module.showDetails"
              >
                <b-tr class="folder-row">
                  <b-td>
                    <div
                      v-if="folder.tables && folder.tables.length > 0"
                      class="text-center padding-13"
                    >
                      <font-awesome-icon
                        v-if="!folder.showDetails"
                        :icon="['fas', 'plus']"
                        @click="toggleFolder(folder,module)"
                      />
                      <font-awesome-icon
                        v-if="folder.showDetails"
                        :icon="['fas', 'minus']"
                        @click="toggleFolder(folder,module)"
                      />
                    </div>
                  </b-td>

                  <b-td class="folder-padding">
                    {{ folder.id }}
                  </b-td>
                  <b-td>{{ folder.type }}</b-td>
                  <b-td>{{ folder.folderName }}</b-td>
                  <b-td>{{ folder.deletedBy }}</b-td>
                  <b-td>{{ folder.deletedAt }}</b-td>
                  <b-td>
                    <b-btn
                      v-if="folder.deletedAt"
                      size="sm"
                      variant="success"
                      @click="onRestoreFolder(folder, module)"
                    >
                      Restore
                    </b-btn>
                  </b-td>
                </b-tr>

                <b-tr
                  v-for="table in folder.tables"
                  v-if="folder.showDetails"
                  class="table-row"
                >
                  <b-td />
                  <b-td class="table-padding">
                    {{ table.id }}
                  </b-td>
                  <b-td>{{ table.type }}</b-td>
                  <b-td>{{ table.name }}</b-td>
                  <b-td>{{ table.deletedBy }}</b-td>
                  <b-td>{{ table.deletedAt }}</b-td>
                  <b-td>
                    <b-btn
                      v-if="table.deletedAt"
                      size="sm"
                      variant="success"
                      @click="onRestoreTable(table,folder,module)"
                    >
                      Restore
                    </b-btn>
                  </b-td>
                </b-tr>
              </template>
            </template>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-card>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions, mapGetters} = createNamespacedHelpers('dataManagement');

export default {
  name: 'RecycleBin',
  data: () => {
    return {
      searchInput: null,
      selected: null,
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'type', label: 'Type'},
        {key: 'name', label: 'Name'},
        {key: 'deleted_by', label: 'Deleted by'},
        {key: 'deleted_at', label: 'Deleted at'},
        {key: 'actions'},
      ],
      items: [],
      originalItems: [],
      currentItems: [],
      searchFilter: null,
    };
  },
  computed: {
    ...mapState(['recycleBin']),
    hasOneRowOpen() {
      for (const item of this.items) {
        if (item['_showDetails']) {
          return true;
        }
      }
    },
  },
  methods: {
    ...mapActions(['getRecycleBinData', 'updateRecycleBin', 'restoreModule', 'restoreFolder', 'restoreTable']),

    getFolderClass(module) {
      const folderIsOpened = module.folders.findIndex(folder => folder.showDetails);
      module.folders = module.folders.map((folder) => {

        if (module.showDetails) {
          folder.class = 'rule-line width-2';
        }

        if (folder.showDetails) {
          folder.class = 'rule-line width-4';
          folder.tables = folder.tables.map((table) => {
            table.class = 'rule-line width-6';
            return table;
          });
        }

        return folder;
      });
    },
    toggleModule(module) {
      module.showDetails = !module.showDetails;
      module.folders = module.folders.map(folder => {
        folder.class = 'rule-line width-2';
        return folder;
      });
    },
    toggleFolder(folder, module) {
      folder.showDetails = !folder.showDetails;
      this.getFolderClass(module);
    },
    searchChanged(inputVal) {
      if (this.originalItems.length === 0) {
        this.originalItems = JSON.parse(JSON.stringify(this.recycleBin.data));
      }

      if (inputVal.trim().length === 0) {
        this.updateRecycleBin(this.originalItems);
        return;
      }

      inputVal = inputVal.toLowerCase();
      const filteredData = this.originalItems.filter((module) => {
        const filteredFolders = module.folders.filter((folder) => {
          const filteredTables = folder.tables.filter((table) => {
            return table.name.toLowerCase().includes(inputVal);
          });
          const showTables = filteredTables.length > 0 || folder.folderName.toLowerCase().includes(inputVal);

          if (filteredTables.length > 0) {
            folder.tables = filteredTables;
            this.toggleFolder(folder, module);
          }
          return showTables;
        });

        const showFolders = filteredFolders.length > 0 || module.moduleName.toLowerCase().includes(inputVal);
        if (filteredFolders.length > 0) {
          module.folders = filteredFolders;
          this.toggleModule(module);
        }
        return showFolders;
      });
      this.updateRecycleBin(filteredData);
    },
    async onRestoreModule(item) {
      const response = await this.restoreModule(item);
      if (response.success) {
        this.searchFilter = null;
        this.$toasted.success(`Module "${item.name}" was Restored`, {
          duration: TOASTER_DURATION,
        });
      } else {
        this.$toasted.error('Module restored', {
          duration: TOASTER_DURATION,
        });
      }
    },
    async onRestoreFolder(item, module) {
      let confirm = true;
      if (module.deletedAt !== null) {
        confirm = await this.$confirm('Restoring folder...',
          `Folder can not be restored without Module: '${module.moduleName}'. Are you sure you want to continue?`);
      }
      if (confirm) {
        if (confirm) {
          const response = await this.restoreFolder(item);
          if (response.success) {
            this.searchFilter = null;
            this.$toasted.success('Folder Restored', {
              duration: TOASTER_DURATION,
            });
          }
        }
      }


    },
    async onRestoreTable(item, folder, module) {
      let needConfirm = false;
      let confirm = true;
      let confirmString = '';
      if (module.deletedAt !== null) {
        confirmString += `Module '${module.moduleName}'`;
        needConfirm = true;
      }

      if (folder.deletedAt !== null) {
        confirmString += `${needConfirm ? ', ' : ''}Folder '${folder.folderName}'`;
        needConfirm = true;
      }

      if (needConfirm) {
        confirm = await this.$confirm('Restoring table...',
          `Table can not be restored without ${confirmString}. Are you sure you want to continue?`);
      }

      if (confirm) {
        const response = await this.restoreTable(item);
        if (response.success) {
          this.searchFilter = null;
          this.$toasted.success('Table Restored', {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
  },
  async mounted() {
    this.originalItems = this.items;
    await this.getRecycleBinData();
    this.searchFilter = this.$route.query.search;
    if (this.searchFilter) {
      this.searchChanged(this.searchFilter);
    }

  },
};
</script>

<style lang="scss" scoped>

  .recycle-bin-table {
    tr {
      height: 1px;

      td:first-child {
        height: inherit;
        padding: 0;
      }
    }
  }

  .rule-line {
    background-color: #19407B;
    height: 100%;
  }

  .width-2 {
    width: 2px;
  }

  .width-4 {
    width: 4px;
  }

  .width-6 {
    width: 6px;
  }

  .table-container {
    max-height: 70vh;
    overflow-y: scroll
  }

  .padding-13 {
    padding-top: 13px;
  }

  .module-padding {
    padding-left: 15px;
  }

  .folder-padding {
    padding-left: 30px;
  }

  .table-padding {
    padding-left: 45px;
  }
</style>
